export const localeTextSpanish = {
  // Paginación
  MuiTablePagination: {
    labelRowsPerPage: 'Filas por página:',
    labelDisplayedRows: ({ from, to, count }) =>
      `${from}–${to} de ${count !== -1 ? count : `más de ${to}`}`,
  },

  // Textos generales
  noRowsLabel: 'Sin resultados',
  noResultsOverlayLabel: 'Sin coincidencias',

  // Toolbar
  toolbarDensity: 'Densidad',
  toolbarDensityLabel: 'Densidad',
  toolbarDensityCompact: 'Compacta',
  toolbarDensityStandard: 'Estándar',
  toolbarDensityComfortable: 'Cómoda',
  toolbarColumns: 'Columnas',
  toolbarColumnsLabel: 'Seleccionar columnas',
  toolbarFilters: 'Filtros',
  toolbarFiltersLabel: 'Mostrar filtros',
  toolbarFiltersTooltipHide: 'Ocultar filtros',
  toolbarFiltersTooltipShow: 'Mostrar filtros',
  toolbarFiltersTooltipActive: (count) =>
    `${count} filtro${count !== 1 ? 's' : ''} activo${count !== 1 ? 's' : ''}`,
  toolbarExport: 'Exportar',
  toolbarExportLabel: 'Exportar',
  toolbarExportCSV: 'Descargar como CSV',
  toolbarExportPrint: 'Imprimir',

  // Panel de columnas
  columnsPanelTextFieldLabel: 'Buscar columna',
  columnsPanelTextFieldPlaceholder: 'Título de columna',
  columnsPanelDragIconLabel: 'Reordenar columna',
  columnsPanelShowAllButton: 'Mostrar todas',
  columnsPanelHideAllButton: 'Ocultar todas',

  // Panel de filtros
  filterPanelAddFilter: 'Agregar filtro',
  filterPanelDeleteIconLabel: 'Eliminar',
  filterPanelLinkOperator: 'Operador lógico',
  filterPanelOperators: 'Operadores',
  filterPanelOperatorAnd: 'Y',
  filterPanelOperatorOr: 'O',
  filterPanelColumns: 'Columnas',
  filterPanelInputLabel: 'Valor',
  filterPanelInputPlaceholder: 'Valor del filtro',

  // Operadores de filtro
  filterOperatorContains: 'contiene',
  filterOperatorEquals: 'igual a',
  filterOperatorStartsWith: 'empieza con',
  filterOperatorEndsWith: 'termina con',
  filterOperatorIs: 'es',
  filterOperatorNot: 'no es',
  filterOperatorAfter: 'después de',
  filterOperatorOnOrAfter: 'en o después de',
  filterOperatorBefore: 'antes de',
  filterOperatorOnOrBefore: 'en o antes de',
  filterOperatorIsEmpty: 'está vacío',
  filterOperatorIsNotEmpty: 'no está vacío',
  filterOperatorIsAnyOf: 'es cualquiera de',

  // Footer
  footerRowSelected: (count) =>
    `${count.toLocaleString()} fila${count !== 1 ? 's' : ''} seleccionada${count !== 1 ? 's' : ''}`,
  footerTotalRows: 'Total de filas:',

  // Column menu
  columnMenuLabel: 'Menú',
  columnMenuShowColumns: 'Mostrar columnas',
  columnMenuFilter: 'Filtrar',
  columnMenuHideColumn: 'Ocultar',
  columnMenuUnsort: 'Quitar orden',
  columnMenuSortAsc: 'Orden ascendente',
  columnMenuSortDesc: 'Orden descendente',

  // Selección
  checkboxSelectionHeaderName: 'Selección',
  booleanCellTrueLabel: 'sí',
  booleanCellFalseLabel: 'no',

  // Agrupación (si usas `DataGridPro`)
  groupingColumnHeaderName: 'Grupo',
  groupColumn: (name) => `Grupo por ${name}`,
  ungroupColumn: (name) => `Quitar agrupación por ${name}`,

  // Column pinning (si usas Pro/Enterprise)
  pinToLeft: 'Fijar a la izquierda',
  pinToRight: 'Fijar a la derecha',
  unpin: 'Quitar fijación',
};
